'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'

interface ReadmeTabsControlProps {
  packages: string[]
  activeTab: string
  onTabChange: (tab: string) => void
  isExpanded: boolean
  onExpandChange: (expanded: boolean) => void
}

export function ReadmeTabsControl({ 
  packages, 
  activeTab,
  isExpanded,
  onExpandChange
}: ReadmeTabsControlProps) {
  const router = useRouter()
  const searchParams = useSearchParams()

  const handleTabChange = (tab: string) => {
    const params = new URLSearchParams(searchParams.toString())
    params.set('tab', tab)
    router.push(`?${params.toString()}`)
  }

  return (
    <div className="flex flex-col">
      <div className="border-b border-[#E5E5E5]">
        <div className="flex overflow-x-auto">
          {packages.map(pkg => (
            <button
              key={pkg}
              onClick={() => handleTabChange(pkg)}
              className={`px-6 py-3 font-medium whitespace-nowrap ${
                activeTab === pkg
                  ? 'text-[#0066CC] border-b-2 border-[#0066CC]'
                  : 'text-gray-600 hover:text-[#0066CC]'
              }`}
            >
              {pkg}
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={() => onExpandChange(!isExpanded)}
        className="w-full p-3 flex items-center justify-center text-gray-600 hover:text-[#0066CC] border-t border-[#E5E5E5] mt-auto"
      >
        {isExpanded ? (
          <>
            Show Less <IconChevronUp className="ml-1" />
          </>
        ) : (
          <>
            Show More <IconChevronDown className="ml-1" />
          </>
        )}
      </button>
    </div>
  )
} 